// Function to determine the payment type
export const getPaymentType = payment => {
  const paymentNameLower = payment?.PaymentName?.toLowerCase()
  return {
    isCreditCard: paymentNameLower?.includes('crédito'),
    isCreditAccount: paymentNameLower?.includes('comercial'),
    isCmf: paymentNameLower?.includes('cmf'),
    isYappy: paymentNameLower?.includes('yappy'),
  }
}

// Function to extract the last 4 digits of the credit card
export const getCreditCardLastFourDigits = (payment, isCreditCard, isCmf) => {
  if (isCmf) {
    return (
      payment?.PaymentMethodDetails?.CMF?.TDCSales?.UDTRows?.[0]?.UserFieldsList?.find(
        item => item?.FieldName === 'U_CreditCard'
      )?.FieldValue || ''
    ).slice(-4)
  }
  if (isCreditCard) {
    return (
      payment?.PaymentMethodDetails?.PaymentAttributes?.find(item =>
        item?.PaymentTypeAttributeId?.includes('Ultimo4Digitos')
      )?.CustomInformation || ''
    ).slice(-4)
  }
  return ''
}

// Function to get the Yappy confirmation number
export const getYappyConfirmationNumber = payment => {
  const CONFIRMATION_NUMBER_ID = 'ConfirmationNumber'
  const paymentMethodAttributes = []

  if (Array.isArray(payment?.PaymentMethodDetails?.PaymentAttributes)) {
    paymentMethodAttributes.push(
      ...payment?.PaymentMethodDetails?.PaymentAttributes
    )
  } else {
    paymentMethodAttributes.push(
      payment?.PaymentMethodDetails?.PaymentAttributes
    )
  }

  const confirmationAttribute = paymentMethodAttributes?.find(
    attribute => attribute?.PaymentTypeAttributeId === CONFIRMATION_NUMBER_ID
  )

  return confirmationAttribute?.CustomInformation || 'no disponible'
}

// Function to generate the payment label
export const getPaymentLabel = (
  payment,
  isCmf,
  isCreditCard,
  isCreditAccount,
  lastFourDigits
) => {
  if (isCmf) return `: ${lastFourDigits} Cuota fija: $`
  if (isCreditAccount) return `: $`
  if (isCreditCard) return `: ${lastFourDigits} $`
  return ' $'
}
